import { forwardRef, memo, useImperativeHandle, useRef, useState } from 'react';
import { NavBarSection } from '@apps/layouts/Navbar/styles';
import { ListItem } from '@mui/material';
import classNames from 'classnames';

import CarOverviewHeaderNavBarItemProps, {
  CarOverviewNavItemRefProps,
} from './props';
import { CarOverviewNavBarItem, navItems } from './settings';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarOverviewHeaderNavBarItemView: React.ForwardRefRenderFunction<
  CarOverviewNavItemRefProps,
  CarOverviewHeaderNavBarItemProps
> = (props, ref) => {
  const { handleClick } = props;

  // ======================= HOOKS
  const navItemElementRef = useRef<HTMLUListElement | null>(null);
  const [focusedNavItem, setFocusedNavItem] =
    useState<CarOverviewNavBarItem>('Summary');

  // ======================= EFFECTS
  useImperativeHandle(
    ref,
    () => ({
      focusedNavItem,
      setFocusedNavItem,
      element: navItemElementRef.current,
    }),
    [focusedNavItem, setFocusedNavItem, navItemElementRef]
  );

  // ======================= VIEWS
  return (
    <NavBarSection
      ref={navItemElementRef}
      style={{
        paddingTop: '8px',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'scroll',
        whiteSpace: 'nowrap',
        margin: '0 auto',
        maxWidth: 1240,
        scrollbarWidth: 'none',
      }}
    >
      {navItems.map((navItem, index) => {
        const { key, title } = navItem;
        const isSelected = focusedNavItem === navItem.key;
        return (
          <ListItem
            key={`${index}`}
            id={`carOverviewNavItem_${key}`}
            onClick={(event) => handleClick(event, key)}
            className={classNames('nav-item-overview text-md-unchanged ', {
              'nav-ani-overview-selected': isSelected,
              'nav-ani-overview': !isSelected,
            })}
            sx={{
              cursor: 'pointer',
              padding: '5px 20px',
              '&.MuiListItem-root': {
                width: 'auto',
              },
            }}
          >
            {title}
          </ListItem>
        );
      })}
    </NavBarSection>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export const CarOverviewHeaderNavBarItem = memo(
  forwardRef(CarOverviewHeaderNavBarItemView)
);
